// extracted by mini-css-extract-plugin
export default {"footer_container":"FooterSection_footer_container__OUk13","contact_section":"FooterSection_contact_section__awFke","footer_contacts":"FooterSection_footer_contacts__yR-IL"};